var render = function render(){var _vm=this,_c=_vm._self._c;return _c('emd-modal',{attrs:{"has-header":"","open":_vm.open},on:{"close":function($event){return _vm.$emit('close')}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('b',[_vm._v(" "+_vm._s(_vm.$t('header'))+" ")])]},proxy:true},{key:"content",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }